import {
  BasketballPeriodType, BasketballScoreType, BoxingScoreType,
  ESportsPeriodType, ESportsScoreType, FutsalPeriodType,
  HandballPeriodType, HandballScoreType, IceHockeyPeriodType, IceHockeyScoreType,
  SoccerPeriodType, SoccerScoreType, TableTennisPeriodType, TableTennisScoreType,
  TennisPeriodType, TennisScoreType, VolleyballPeriodType, VolleyballScoreType,
} from './betting-entities';

export enum TeamId {
  FIRST = 1,
  SECOND = 2,
}

export const TEAMS = [TeamId.FIRST, TeamId.SECOND];

export enum SportId {
  SOCCER = 1,
  TENNIS = 2,
  TABLE_TENNIS = 3,
  BASKETBALL = 7,
  ICE_HOCKEY = 8,
  HANDBALL = 11,
  HOCKEY_WITH_BALL = 15,
  FIELD_HOCKEY = 16,
  FUTSAL = 21,
  VOLLEYBALL = 18,
  BEACH_VOLLEYBALL = 19,
  WATER_POLO = 22,
  BOXING_AND_MMA = 24,
  DOTA = 28,
  E_SPORT = 141,
  CS_GO = 201,
  BADMINTON = 241,
}

// ---

type SportIdKeyMap = {
  [key: number]: string;
};

export const SPORT_NAMES_BY_ID: SportIdKeyMap = {
  [SportId.SOCCER]: 'soccer',
  [SportId.TENNIS]: 'tennis',
  [SportId.TABLE_TENNIS]: 'table-tennis',
  [SportId.BASKETBALL]: 'basketball',
  [SportId.ICE_HOCKEY]: 'ice-hockey',
  [SportId.HANDBALL]: 'handball',
  [SportId.FUTSAL]: 'futsal',
  [SportId.VOLLEYBALL]: 'volleyball',
  [SportId.BOXING_AND_MMA]: 'boxing-and-mma',
  [SportId.E_SPORT]: 'e-sport',
  [SportId.CS_GO]: 'cs-go',
  [SportId.DOTA]: 'dota',
  [SportId.HOCKEY_WITH_BALL]: 'hockey-with-ball',
  [SportId.FIELD_HOCKEY]: 'field-hockey',
  [SportId.BEACH_VOLLEYBALL]: 'beach-volleyball',
  [SportId.WATER_POLO]: 'water-polo',
  [SportId.BADMINTON]: 'badminton',
};

const UNKNOWN_PERIOD = 0;

export const MATCH_PERIODS_BY_SPORT = {
  [SportId.SOCCER]:      SoccerPeriodType.MATCH,
  [SportId.TENNIS]:      TennisPeriodType.MATCH,
  [SportId.TABLE_TENNIS]: TableTennisPeriodType.MATCH,
  [SportId.BASKETBALL]:  BasketballPeriodType.MATCH,
  [SportId.VOLLEYBALL]:  VolleyballPeriodType.MATCH,
  [SportId.ICE_HOCKEY]:  IceHockeyPeriodType.MATCH,
  [SportId.E_SPORT]: ESportsPeriodType.MATCH,
  [SportId.HANDBALL]: HandballPeriodType.MATCH,
  [SportId.FUTSAL]: FutsalPeriodType.MATCH,
  [SportId.BOXING_AND_MMA]: BoxingScoreType.POINT,
  [SportId.CS_GO]: ESportsPeriodType.MATCH,
  [SportId.DOTA]: ESportsPeriodType.MATCH,
  [SportId.HOCKEY_WITH_BALL]: UNKNOWN_PERIOD,
  [SportId.FIELD_HOCKEY]: UNKNOWN_PERIOD,
  [SportId.BEACH_VOLLEYBALL]: UNKNOWN_PERIOD,
  [SportId.WATER_POLO]: UNKNOWN_PERIOD,
  [SportId.BADMINTON]: UNKNOWN_PERIOD,
};

export const TIME_PERIODS_BY_SPORT = {
  [SportId.SOCCER]:      SoccerPeriodType.TIME,
  [SportId.TENNIS]:      TennisPeriodType.SET,
  [SportId.TABLE_TENNIS]: TableTennisPeriodType.SET,
  [SportId.BASKETBALL]:  BasketballPeriodType.QUARTER,
  [SportId.VOLLEYBALL]:  VolleyballPeriodType.SET,
  [SportId.ICE_HOCKEY]:  IceHockeyPeriodType.PERIOD,
  [SportId.E_SPORT]: ESportsPeriodType.MAP,
  [SportId.HANDBALL]: HandballPeriodType.TIME,
  [SportId.FUTSAL]: FutsalPeriodType.TIME,
  [SportId.BOXING_AND_MMA]: BoxingScoreType.POINT,
  [SportId.CS_GO]: ESportsPeriodType.MAP,
  [SportId.DOTA]: ESportsPeriodType.MAP,
  [SportId.HOCKEY_WITH_BALL]: UNKNOWN_PERIOD,
  [SportId.FIELD_HOCKEY]: UNKNOWN_PERIOD,
  [SportId.BEACH_VOLLEYBALL]: UNKNOWN_PERIOD,
  [SportId.WATER_POLO]: UNKNOWN_PERIOD,
  [SportId.BADMINTON]: UNKNOWN_PERIOD,
};

export const MATCH_TOTAL_SCORES_TYPE_BY_SPORT = {
  [SportId.SOCCER]:      SoccerScoreType.GOAL,
  [SportId.TENNIS]:      TennisScoreType.POINT,
  [SportId.TABLE_TENNIS]: TableTennisScoreType.SET,
  [SportId.BASKETBALL]:  BasketballScoreType.POINT,
  [SportId.VOLLEYBALL]:  VolleyballScoreType.ACE,
  [SportId.ICE_HOCKEY]:  IceHockeyScoreType.GOAL,
  [SportId.DOTA]: ESportsScoreType.MAP,
  [SportId.CS_GO]: ESportsScoreType.MAP,
  [SportId.E_SPORT]: ESportsScoreType.POINT,
  [SportId.HANDBALL]:  HandballScoreType.GOAL,
};
